var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      on: {
        "before-enter": _vm.appearAnimationBefore,
        enter: _vm.appearAnimationEnter,
        leave: _vm.appearAnimationLeave,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.active,
              expression: "active",
            },
          ],
          ref: "modal",
          class: ["z-modal", _vm.classObject],
          attrs: { tabindex: "0" },
        },
        [
          _c("div", {
            staticClass: "z-modal__overlay",
            on: {
              click: function ($event) {
                return _vm.closeModal({ id: _vm.id })
              },
            },
          }),
          _vm._v(" "),
          _vm.active
            ? _c(
                "div",
                { ref: "container", staticClass: "z-modal__container" },
                [
                  _c(
                    "button",
                    {
                      ref: "close-btn",
                      staticClass: "z-modal__close",
                      attrs: { role: "button", title: _vm.text.close },
                      on: {
                        click: function ($event) {
                          return _vm.closeModal({ id: _vm.id })
                        },
                      },
                    },
                    [
                      _c("z-icon", {
                        attrs: {
                          name: "close_light",
                          width: "24",
                          height: "24",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.hasSlotData
                    ? _c(_vm.currentComponent, {
                        ref: "content",
                        tag: "component",
                        attrs: {
                          data: _vm.currentSlide,
                          "offset-top": _vm.offsetTop,
                          "offset-bottom": _vm.offsetBottom,
                          download: _vm.download,
                          theme: _vm.theme,
                          wide: _vm.wide,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasSlotData
                    ? _c(
                        "modal-html",
                        { attrs: { "has-slot-data": _vm.hasSlotData } },
                        [_vm._t("default")],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.pagination && _vm.data && _vm.data.length > 1
                    ? _c(
                        "div",
                        { staticClass: "z-modal__pagination" },
                        _vm._l(_vm.data, function (item, index) {
                          return _c("span", {
                            key: index,
                            class: [
                              "z-modal__pagination-item",
                              {
                                "z-modal__pagination-item--active":
                                  item === _vm.currentSlide,
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.changeSlide(item)
                              },
                            },
                          })
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.hasSlotData && _vm.data && _vm.data.length > 1
                    ? _c("div", { staticClass: "z-modal__navigation" }, [
                        _c(
                          "button",
                          {
                            ref: "nav-prev",
                            staticClass: "z-modal__arrow z-modal__arrow--prev",
                            class: { "is-disabled": !_vm.isPrev("prev") },
                            attrs: { title: _vm.text.prev, role: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.changeSlide("prev")
                              },
                            },
                          },
                          [
                            _c("z-icon", {
                              attrs: {
                                name: "arrow",
                                width: "24",
                                height: "24",
                                dir: "left",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            ref: "nav-next",
                            staticClass: "z-modal__arrow z-modal__arrow--next",
                            class: { "is-disabled": !_vm.isNext("next") },
                            attrs: { title: _vm.text.next, role: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.changeSlide("next")
                              },
                            },
                          },
                          [
                            _c("z-icon", {
                              attrs: {
                                name: "arrow",
                                dir: "right",
                                width: "24",
                                height: "24",
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }